<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (data.mode !== FormMode.Creation) {
                <div class="form-item">
                    <mat-form-field class="mat-form-field-name">
                        <mat-label>Id</mat-label>
                        <input matInput [formControl]="idFormControl" [(ngModel)]="data.record.id" autocomplete="off" />
                    </mat-form-field>
                </div>
            }
            <div class="form-item">
                <mat-form-field class="mat-form-field-action-type">
                    <mat-label>Client</mat-label>
                    <mat-select [formControl]="customerFormControl" [(ngModel)]="data.record.customerId" required>
                        @for (customer of customers; track customer) {
                            <mat-option [value]="customer.id">{{ customer.name }}</mat-option>
                        }
                    </mat-select>
                    @if (customerFormControl?.errors?.required && (customerFormControl?.dirty || customerFormControl.touched)) {
                        <mat-error>Le champ 'Client' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-name">
                    <mat-label>Alias</mat-label>
                    <input matInput [formControl]="aliasFormControl" [(ngModel)]="data.record.alias" autocomplete="off" required />
                    @if (aliasFormControl?.errors?.required && (aliasFormControl?.dirty || aliasFormControl.touched)) {
                        <mat-error>Le champ 'Alias' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [ngClass]="{ hidden: data.mode === FormMode.Reading }" (click)="cancel()">Annuler</button>
        @if (data.mode !== FormMode.Reading) {
            <button mat-raised-button class="accent-button" [mat-dialog-close]="data.record" [disabled]="!isValid">Enregistrer</button>
        } @else {
            <button mat-raised-button class="accent-button" (click)="cancel()">Ok</button>
        }
    </mat-card-actions>
</mat-card>
